import styles from './InterventionCard.module.css';

interface InterventionCardProps {
  eyebrow: string;
  paragraphs: string[];
  stat: string;
  statCaption: string;
  title: string;
}

export function InterventionCard({
  eyebrow,
  paragraphs,
  stat,
  statCaption,
  title,
}: InterventionCardProps) {
  return (
    <article className={styles.card}>
      <div className={styles.copy}>
        <p className={styles.eyebrow}>{eyebrow}</p>
        <h3 className={styles.title}>{title}</h3>
        {paragraphs.map((paragraph) => (
          <p className={styles.body} key={paragraph}>
            {paragraph}
          </p>
        ))}
      </div>
      <div className={styles.statBlock}>
        <p className={styles.stat}>{stat}</p>
        <p className={styles.statCaption}>{statCaption}</p>
      </div>
    </article>
  );
}
